import { ApiTokenListResponse } from "@gymflow/types";

export const tokenPagination = {
  getNextPageParam: (lastPage: ApiTokenListResponse<any>) =>
    lastPage.nextPageToken,
  initialPageParam: undefined as undefined | string,
} as const;
